import { FetchContext } from '../fetch-context';
import { ProgramRef } from '../../models';
import { responseErrorHandler } from '../response-error-handler';

export const getDefaultProgramRef: (
  fetchContext: FetchContext,
  accessToken?: string,
) => Promise<ProgramRef> = (fetchContext, accessToken) => fetch(`${fetchContext.baseUrl}/api/staff/programs/default-program-ref`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<ProgramRef>(fetchContext.errorStore, response, 'get default program ref'));
